import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import AppRoutes from "./AppRoutes";
import { preloadSmallVesselCoefficients } from "./coeffLoader";

const API_BASE = "https://noisemaps.marble.eu";
// https://noisemaps.marble.eu
// "http://localhost:3001"

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 2500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    preloadSmallVesselCoefficients().then(() => {
    });
  }, []);

  // Track visitor
  useEffect(() => {
    const trackVisitor = async () => {
      try {
        await fetch(`${API_BASE}/api/track-visitor`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        });
      } catch (err) {
        console.error('Failed to track visitor:', err);
      }
    };
    
    trackVisitor();
  }, []);

 

  if (isLoading) {
    return (
      <div style={{
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        background: `url(${process.env.PUBLIC_URL}/BACKGROUND.jpeg) no-repeat center center / cover`,
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }}>
        <div style={{
          display: "flex",
          flexDirection: "column",  
          alignItems: "center",
          gap: "15px",              
          marginBottom: "20px",
        }}>
          

          <img
            src={`${process.env.PUBLIC_URL}/SHIPECHO_FULL_TEXT.png`}
            alt="SHIPECHO"
            style={{
              width: "300px",
              maxWidth: "70vw",
              height: "auto",
            }}
          />
          <p
            style={{
              color: "#1E4D8B", 
              fontFamily: "'Montserrat', sans-serif",
              fontSize: "20px",
              marginTop: "-40px",
              marginRight: "-60px",
              letterSpacing: "0.5px",
              textAlign: "center",
            }}
          >
            A Real-time Underwater Noise Map
          </p>
          
        </div>
      </div>
    );
  }


  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}


export default App;
